import React from 'react';
import NewsCardSideBar from '@/components/(postTypes)/news/NewsCardSideBar';
import { NewsPost } from '@/types/news/types';
type Props = {
    allNews?: NewsPost[] | undefined;
    className?: string;
};
const LatestNewsSideBar = ({ allNews, className }: Props) => {
    return (
        <section className={`${className}`}>
            <div className={'mb-6 flex xl:text-xl border-b border-black/10 dark:border-white/10'}>
                <h3 className={'border-b-2 pb-2 border-progress'}>آخرین اخبار</h3>
            </div>
            <div className={'grid sm:grid-cols-2 lg:grid-cols-3 gap-3'}>
                {allNews?.map((node, index) => (
                    <div
                        key={index}
                        id={`post-${index}`}
                        className={
                            'border bg-white hover:bg-gray-50 dark:bg-white/5 hover:dark:bg-white/10 border-primary/5 rounded-2xl  dark:border-white/10'
                        }
                    >
                        <NewsCardSideBar
                            sentiment={node.newsSentiment?.sentiment}
                            index={index}
                            featuredImage={node?.featuredImage}
                            title={node.title}
                            databaseId={node.databaseId}
                            uri={node.uri}
                            date={node.date}
                            categories={node.newsCategories.nodes}
                        />
                    </div>
                ))}
            </div>
        </section>
    );
};

export default LatestNewsSideBar;
